"use client"
import { GetPageByRouteQuery } from "apollo"
import React, { useEffect, useState } from "react"
import { getBreadCrumbs } from "utils"

// Localized iframe titles for accessibility
const iframeTitles: Record<string, string> = {
  he: "מתכנן מסלולים - תוצאות חיפוש נסיעה",
  en: "Journey Planner - Trip Search Results",
  ar: "مخطط الرحلات - نتائج البحث عن الرحلات",
  ru: "Планировщик маршрутов - Результаты поиска поездок",
}

interface JourneyPlannerProps {
  data: GetPageByRouteQuery
  locale: "he" | "en" | "ar" | "ru"
}

const JourneyPlanner: React.FC<JourneyPlannerProps> = ({
  data,
  locale = "he",
}) => {
  const parsedData = data?.page?.properties || []
  // const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  const [iframeUrl, setIframeUrl] = useState("")

  useEffect(() => {
    // Only run on the client side
    if (typeof window !== "undefined") {
      const urlSearchParams = new URLSearchParams(window.location.search)

      // Always use HopOn iframe URL
      const hopOnBaseUrl = "https://www.busnearby.co.il"
      const hopOnParams = new URLSearchParams()
      // Copy all search params to HopOn iframe
      urlSearchParams.forEach((value, key) => {
        if (key === "path") return // Skip our custom param
        hopOnParams.append(key, value)
      })
      hopOnParams.set("locale", locale)
      // Ensure headless mode is enabled for iframe
      hopOnParams.set("headless", "true")
      const path = urlSearchParams.get("path") || "/plan"
      setIframeUrl(`${hopOnBaseUrl}${path}?${hopOnParams.toString()}`)
    }
  }, [locale])

  return (
    <>
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          title={iframeTitles[locale] || iframeTitles.he}
          width="100%"
          height="800px"
          style={{ border: "none" }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "800px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
          }}
        ></div>
      )}
    </>
  )
}

export default JourneyPlanner
